import { FormControlLabel, FormGroup, Switch, FormLabel } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import React, { useCallback, useContext } from 'react';
import { LoggingContext } from '../Context/LoggingContext/LoggingContext';

const useStyles = makeStyles({
  root: {
    transition: 'flex 500ms linear, opacity 500ms ease-in',
    marginBottom: 0,
    '& .MuiFormGroup-root': {
      alignItems: 'center',
    },
    '& .MuiFormLabel-root': {
      textAlign: 'center',
      padding: '0px 20px',
    },
    '& .MuiFormControlLabel-root': {
      textAlign: 'center',
    },
  },
  label: {
    margin: 'auto',
    width: 200,
  },
  switchBase: {
    color: 'secondary.main',
    '&$checked': {
      color: 'secondary.main',
    },
  },
  checked: {},
  track: {
    color: 'secondary.light',
    backgroundColor: 'secondary.light',
  },
});

interface SwitchToggleProps {
  value: 1 | 2.57;
  inputLabels: string[];
  legend: string;
  labelPlacement: 'bottom' | 'top' | 'end' | 'start';
  updateParentValue: (newValue: 1 | 2.57) => void;
}

export default function SwitchToggle({
  value,
  inputLabels,
  legend,
  labelPlacement,
  updateParentValue,
}: SwitchToggleProps) {
  const location = useLocation();
  const classes = useStyles();
  const {addLog} = useContext(LoggingContext)

  function handleChangeFunction(event: React.ChangeEvent<HTMLInputElement>) {
    addLog("cm/inches toggled", location.pathname)
    updateParentValue(event.target.checked ? 1 : 2.57);
  }
  const handleChange = useCallback(handleChangeFunction, []);

  return (
    <FormGroup className={classes.root}>
      <FormLabel component='legend'>{legend}</FormLabel>
      <FormControlLabel
        className={classes.label}
        label={inputLabels[value === 1 ? 0 : 1]}
        labelPlacement={labelPlacement}
        control={
          <Switch
            color='primary'
            inputProps={{ 'aria-label': 'checkbox with default color' }}
            checked={value === 1}
            onChange={handleChange}
            name='checkedB'
            classes={{ switchBase: classes.switchBase, track: classes.track }}
          />
        }
      />
    </FormGroup>
  );
}
